import { debugLog } from "../util/debug";

class maritzAPIClient {
    redeemJWTForApigeeToken = async (jwt) => {
        const response = await fetch("/api/maritz/sso", {
            method: 'POST',
            body: JSON.stringify({
                jwt,
                tenant: localStorage.getItem('cnxtDomain'),
            }),
            headers: {
                'Content-Type': 'application/json',
            }
        });
        return await response.json();
    }

    validateMaritzParticipantsByEmail = async (inputArray = []) => {
        const response = await fetch("/api/maritz/validate-by-email", {
            method: 'POST',
            body: JSON.stringify({
                participantIds: inputArray || [],
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('cnxtAccessToken')}`,
            },
        });
        const statusCheckRaw = await response.json();
        debugLog('validate-by-email: ', statusCheckRaw)

        var returnResult = [];
        inputArray.forEach((inputEmail) => {
            var match = statusCheckRaw.filter((chk) => chk.participantId === inputEmail)[0];

            if (match) {
                returnResult.push(match);
            } else {
                returnResult.push({ id: null, participantId: inputEmail });
            }
        });

        return returnResult;
    }

    getProgramsForSelectedParticipants = async (inputArray = []) => {
        const response = await fetch("/api/maritz/programs-for-participants", {
            method: 'POST',
            body: JSON.stringify({
                recipientIds: inputArray || [],
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('cnxtAccessToken')}`,
            },
        });
        const result = await response.json();
        debugLog('programs-for-participants: ', result)
        return result
    }

    getProgramDetailsById = async (programId) => {
        const response = await fetch("/api/maritz/program-details", {
            method: 'POST',
            body: JSON.stringify({
                programId,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('cnxtAccessToken')}`,
            },
        });
        const result = await response.json();
        debugLog('program detail: ', result);
        return result
    }

    getBudgetsByProgramId = async (programId) => {
        const response = await fetch("/api/maritz/program-budgets", {
            method: 'POST',
            body: JSON.stringify({
                programId,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('cnxtAccessToken')}`,
            },
        });
        const result = await response.json();
        debugLog('budgets: ', result)
        return result;
    }

    submitRecognition = async (submission) => {
        const response = await fetch("/api/maritz/recognitions", {
            method: 'POST',
            body: JSON.stringify({
                submission,
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('cnxtAccessToken')}`,
            },
        });
        return await response.json();
    }
}

export default maritzAPIClient;